export default "__VITE_PUBLIC_ASSET__a5bcd05a__"